export function positiveModulo(value: number, divisor: number): number {
    return ((value % divisor) + divisor) % divisor;
}
